import { render, staticRenderFns } from "./VInventoryItemRequests.vue?vue&type=template&id=1fc40a26"
import script from "./VInventoryItemRequests.vue?vue&type=script&lang=js"
export * from "./VInventoryItemRequests.vue?vue&type=script&lang=js"
import style0 from "./VInventoryItemRequests.vue?vue&type=style&index=0&id=1fc40a26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports